import { apiClient } from '@shared/utils/api-client';

export interface AdminNotificationItem {
  id: number;
  category: string;
  title: string;
  body: string | null;
  status: 'UNREAD' | 'READ';
  data: unknown;
  createdAt: string;
}

export interface AdminNotificationsResponse {
  items: AdminNotificationItem[];
  total: number;
}

export const adminNotificationsApi = {
  getUnreadCount: () =>
    apiClient.get<{ count: number }>('/admin-notifications/me/unread-count'),

  list: async (params?: { limit?: number; offset?: number; unreadOnly?: boolean }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.offset != null) search.set('offset', String(params.offset));
    if (params?.unreadOnly === true) search.set('unreadOnly', 'true');
    const q = search.toString();
    return apiClient.get<AdminNotificationsResponse>(
      `/admin-notifications/me${q ? `?${q}` : ''}`,
    );
  },

  markRead: (id: number) =>
    apiClient.patch<{ ok: boolean }>(`/admin-notifications/me/${id}/read`, {}),

  markAllRead: () =>
    apiClient.patch<{ ok: boolean }>('/admin-notifications/me/read-all', {}),
};
